module.exports = __webpack_public_path__ + "static/media/graffiti_kings.f8bd5ac9.webp";